import { useTenant } from '../../tenant/useTenant'
import { HomeHero } from './HomeHero'
import { HomeCatalog } from './HomeCatalog'
import { HomeLocations } from './HomeLocations'
import { HomeSocial } from './HomeSocial'

export function HomePage() {
  const { bootstrap } = useTenant()
  const { vendor } = bootstrap

  return (
    <>
      <HomeHero />

      {vendor.about && (
        <section className="container-page py-section-gap-md">
          <p className="mx-auto max-w-3xl whitespace-pre-line text-center font-body-lg text-body-lg text-on-surface-variant">
            {vendor.about}
          </p>
        </section>
      )}

      <HomeCatalog />
      <HomeLocations />
      <HomeSocial />
    </>
  )
}
